import { PreferredGame } from "./PreferredGame";
import { ReactChat } from "../react/ReactChat";
import { MapHelper } from "../functions/MapHelper";

class PreferredGames {

	constructor(data) {
		this.games = new Map();
		if(!data) {
			return;
		}
		if(data instanceof PreferredGames) {
			throw 'Invalid data..';
		}
		else {
			this.update(data);
		}
	}

	numberOfEnabledGames() {
		let count = 0;
		for(let [i, game] of this.games) {
			if(game.isEnabled()) {
				count++;
			}
		}
		return count;
	}

	get size(){
		return this.games.size;
	}

	retrieve(ladderId) {
		ladderId = Number.parseInt(ladderId);
		return this.games.get(ladderId);
	}

	removeAllElements() {
		for(let [i, game] of this.games) {
			game.removeElement();
		}
	}

	all() {
		return this.games;
	}

	thatHaveDolphinBuilds() {

	}

	add(ladder) {
		if(ladder instanceof PreferredGame) {
			this.games.set(Number.parseInt(ladder.id, 10), ladder);
		}
		else {
			console.log(ladder);
			console.error('Used an invalid ladder');
		}
	}

	update(data, user) {
		this.games.clear();
		if(data instanceof PreferredGames) {

			this.games = data.games;
			return this;
		}

		for(var i in data) {
			if(!data.hasOwnProperty(i)) {
				continue;
			}
			let game = data[i];
			if(!(game instanceof PreferredGame)) {
				game = new PreferredGame(game);
			}
			this.games.set(Number.parseInt(i, 10), game);
		}
		MapHelper.inPlaceSort(this.games, ([_, a], [__, b]) => {
			return a.order_by > b.order_by ? 1 : -1;
		});
		return this;
	}
}


export { PreferredGames };